//Collection Filter Top Button Clicking Start
//Collection Filter All button Top Set Clickcing in Filter
let topForm = document.getElementById('formFilterTopButton');
let firtLayerForm = document.getElementById('FacetFiltersForm');

if (document.querySelector('#layerOne.dekbedovertrekken')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //DEKBEDOVERTREK
    if (e.target.value == '1-Persoons') {
      document
        .querySelector('#layerOne.dekbedovertrekken')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == '2-Persoons') {
      document
        .querySelector('#layerOne.dekbedovertrekken')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == 'Lits-Jumeaux') {
      document
        .querySelector('#layerOne.dekbedovertrekken')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    }
  });
}
if (document.querySelector('#layerOne.hoeslakens')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //HOESLAKENS
    if (e.target.value == 'Kinderen') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector(
          '#FacetFiltersForm details:nth-child(7) ul li:nth-child(1) label input'
        )
        .click();
    } else if (e.target.value == '90 cm') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == '120 cm') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == '140 cm') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    } else if (e.target.value == '160 cm') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(4) label input')
        .click();
    } else if (e.target.value == '180 cm') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(5) label input')
        .click();
    } else if (e.target.value == '200 cm') {
      document
        .querySelector('#layerOne.hoeslakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(6) label input')
        .click();
    }
  });
}
if (document.querySelector('#layerOne.moltons')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //MOLTONS
    if (e.target.value == 'Kinderen') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector(
          '#FacetFiltersForm details:nth-child(8) ul li:nth-child(1) label input'
        )
        .click();
    } else if (e.target.value == '90 cm') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == '120 cm') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == '140 cm') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    } else if (e.target.value == '160 cm') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(4) label input')
        .click();
    } else if (e.target.value == '180 cm') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(5) label input')
        .click();
    } else if (e.target.value == '200 cm') {
      document
        .querySelector('#layerOne.moltons')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(6) label input')
        .click();
    }
  });
}
if (document.querySelector('#layerOne.lakens')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //LAKENS
    if (e.target.value == '1-Persoons') {
      document
        .querySelector('#layerOne.lakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == '2-Persoons') {
      document
        .querySelector('#layerOne.lakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == 'Lits-Jumeaux') {
      document
        .querySelector('#layerOne.lakens')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    }
  });
}
if (document.querySelector('#layerOne.keukentextiel')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //Keukentextiel
    if (e.target.value == 'Theedoeken') {
      document
        .querySelector('#layerOne.keukentextiel')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == 'Keukendoeken') {
      document
        .querySelector('#layerOne.keukentextiel')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == 'Microvezeldoeken') {
      document
        .querySelector('#layerOne.keukentextiel')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    } else if (e.target.value == 'Schorten') {
      document
        .querySelector('#layerOne.keukentextiel')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(4) label input')
        .click();
    }
  });
}
if (document.querySelector('#layerOne.tafellinnen')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //TAFELLIMEN
    if (e.target.value == 'Servetten') {
      document
        .querySelector('#layerOne.tafellinnen')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == 'Tafellaken') {
      document
        .querySelector('#layerOne.tafellinnen')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == 'Tafelloper') {
      document
        .querySelector('#layerOne.tafellinnen')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    }
  });
}
if (document.querySelector('#layerOne.handhanddoekon')) {
  document.querySelector('#layerOne').addEventListener('click', (e) => {
    //hand-handdoekon
    if (e.target.value == 'Handdoek') {
      document
        .querySelector('#layerOne.handhanddoekon')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(1) label input')
        .click();
    } else if (e.target.value == 'Badhanddoek') {
      document
        .querySelector('#layerOne.handhanddoekon')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(2) label input')
        .click();
    } else if (e.target.value == 'Badlaken XL') {
      document
        .querySelector('#layerOne.handhanddoekon')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(3) label input')
        .click();
    } else if (e.target.value == 'Badmat') {
      document
        .querySelector('#layerOne.handhanddoekon')
        .closest('#filterTopHdCollection')
        .nextElementSibling.querySelector('#FacetFiltersForm ul li:nth-child(4) label input')
        .click();
    }
  });
}
//Collection Filter Top Button Clicking End

//Collection Page Refresh/Load working Start ++ Count Total Size
if (document.getElementById('filterActiveValueCountSec') && document.getElementById('layerOne')) {
  function collectionPageLoad() {
    // Count Total Filter Number
    var layerOne = document.getElementById('layerOne');
    if (!layerOne) return;

    var filterValueSize = document.querySelectorAll('#filterActiveValueCountSec .filterValuSize');
    var totalSize = 0;

    filterValueSize.forEach((element) => {
      totalSize = totalSize + (parseInt(element.value) || 0);
    });

    if (totalSize > 0) {
      layerOne.style.display = 'none';
    } else {
      layerOne.style.display = 'block';
    }
  }

  // Run once when the page loads
  collectionPageLoad();

  // Run only when filter HTML changes (replaces the endless setInterval)
  let pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      collectionPageLoad();
    });
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('popstate', collectionPageLoad);
}
// Collection Page Refresh/Load working End

//Collection Description Open close
const collectionShowMore = document.querySelector('.show_more_btn');
const collectionLessMore = document.querySelector('.less_more_btn');
if (collectionShowMore) {
  collectionShowMore.addEventListener('click', function (e) {
    e.preventDefault();
    this.parentElement.parentElement.querySelector('.collection-hero__description').classList.add('open');
  });
}
if (collectionLessMore) {
  collectionLessMore.addEventListener('click', function (e) {
    e.preventDefault();
    this.parentElement.parentElement.querySelector('.collection-hero__description').classList.remove('open');
  });
}